import { STATE_KEYS, LOGIN_STATE } from '../constants';

const userSelector = (state) => state[STATE_KEYS.User] || {};

const loginStateSelector = (state) => {
    return userSelector(state)[STATE_KEYS.LoginState] || LOGIN_STATE.LoggedOut;
};

const notificationsSelector = (state) => {
    return userSelector(state)[STATE_KEYS.Notifications] || [];
};

const appointmentsSelector = (state) => {
    return userSelector(state)[STATE_KEYS.UpcomingAppointments] || [];
};

export {
    appointmentsSelector,
    loginStateSelector,
    notificationsSelector,
    userSelector,
};
